import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";
import { selectCurrentStep } from "./cartSlice";

interface ProgressBarProps {}

const steps = [
  { id: 1, title: "Преглед на продуктите" },
  { id: 2, title: "Информация за доставка" },
  { id: 3, title: "Завършена поръчка" },
];

const ProgressBar: React.FC<ProgressBarProps> = ({}) => {
  const currentStep = useSelector(selectCurrentStep);

  return (
    <ProgressBarContainer>
      <Bar>
        {steps.map((item) => {
          const isActive = item.id <= currentStep;
          return (
            <BarItem
              key={item.id}
              className={`text-sm ${isActive ? "active" : ""}`}
            >
              {item.title}
            </BarItem>
          );
        })}
      </Bar>
    </ProgressBarContainer>
  );
};

const ProgressBarContainer = styled.div`
  width: 100%;
`;
const Bar = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;
  counter-reset: step;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

const BarItem = styled.li`
  list-style: none;
  display: inline-block;
  position: relative;
  text-align: center;
  cursor: pointer;
  flex-basis: 33.33%;
  color: ${colors.dark_gray};

  &:before {
    content: counter(step);
    counter-increment: step;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border: 1px solid ${colors.gray};
    border-radius: 100%;
    display: block;
    text-align: center;
    margin: 0 auto 10px auto;
    background-color: ${colors.dark_gray};
    color: ${colors.gray};
  }

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: ${colors.dark_gray};
    top: 15px;
    left: -50%;
    z-index: -1;
  }

  &:first-child:after {
    content: none;
  }

  &.active {
    color: black;
  }

  &.active:before {
    border-color: ${colors.lighter_blue};
    background-color: ${colors.lighter_blue};
    color: white;
  }

  &.active + &:after {
    background-color: ${colors.lighter_blue};
  }
`;

export default ProgressBar;
